import React from 'react';
import { FormGroup, ControlLabel, FormControl, Panel, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { isEmpty, isArray, map } from 'lodash';
import TariffRatesPropsEditor from './TariffRatesPropsEditor';
import OriginDestinationTable from './OriginDestinationTable';
import PalletBaseTable from './PalletBaseTable';
const isFloatZeroOrLower = a => a.toFixed(2) === '0.00' || a < 0;
export default class TariffRatesEditor extends React.Component {
    handlePropertiesChange() {
        return (key, value) => {
            const tariffRate = this.props.tariffRate;
            tariffRate[key] = value;
            const propertiesValid = (tariffRate.name && tariffRate.name.length > 0);
            this.notifyUpdate(tariffRate, true, propertiesValid);
        };
    }
    handleODPairsChange() {
        return (ODPairsData) => {
            const tariffRate = this.props.tariffRate;
            tariffRate.od_pairs = ODPairsData.od_pairs;
            const ODPairsValid = this.validateODPairs(tariffRate.od_pairs);
            this.notifyUpdate(tariffRate, true, ODPairsValid);
        };
    }
    handlePricesDataChange() {
        return (pricesData) => {
            const tariffRate = this.props.tariffRate;
            let valid = true;
            for (const property in pricesData) {
                tariffRate[property] = pricesData[property];
            }
            for (const property in tariffRate) {
                if (property.match('ranges')) {
                    if (!(tariffRate.type === 'weightDistance' && property === 'load_ranges')) {
                        valid = valid && this.validateRanges(tariffRate[property]);
                    }
                }
            }
            const priceMatrixValid = (valid && this.validatePrices(tariffRate));
            this.notifyUpdate(tariffRate, true, priceMatrixValid);
        };
    }
    handleRatePerDayChange() {
        return (e) => {
            const tariffRate = this.props.tariffRate;
            const ratePerDay = e.target.value;
            tariffRate.rate_per_day = ratePerDay;
            const valid = (ratePerDay && ratePerDay > 0);
            this.notifyUpdate(tariffRate, true, valid);
        };
    }
    validateODPairs(ODPairs) {
        let valid = true;
        if (ODPairs) {
            for (let index = 0; index < ODPairs.length; ++index) {
                const ODPair = ODPairs[index];
                valid = valid && !isEmpty(ODPair.origin_city.city);
                valid = valid && !isEmpty(ODPair.destination_city.city);
                valid = valid && this.validateValues(map(ODPair.values, 'value'), true);
            }
        }
        return valid;
    }
    validateValues(values, isZero) {
        let valid = true;
        if (isArray(values)) {
            for (const value of values) {
                if (isZero) {
                    if (value < 0) {
                        valid = false;
                        break;
                    }
                }
                else {
                    if (isFloatZeroOrLower(value)) {
                        valid = false;
                        break;
                    }
                }
            }
        }
        return valid;
    }
    validateRanges(ranges) {
        let valid = true;
        if (ranges) {
            for (let index = 0; index < ranges.length; ++index) {
                const range = ranges[index];
                if (isArray(range)) {
                    valid = (range[0] >= 0 && range[1] >= range[0]);
                    if (!valid) {
                        break;
                    }
                }
                else {
                    break;
                }
            }
        }
        return valid;
    }
    validatePrices(pricesData) {
        let valid = true;
        if (pricesData.prices) {
            for (let index = 0; index < pricesData.prices.length; ++index) {
                const row = pricesData.prices[index];
                valid = this.validateValues(row, false);
                if (!valid)
                    break;
            }
        }
        return valid;
    }
    notifyUpdate(tariffRate, edited, valid) {
        if (this.props.onChange) {
            this.props.onChange(tariffRate, edited, valid);
        }
    }
    renderPalletBaseTable() {
        const display = this.props.tariffRate.type === 'palletBase' ? 'block' : 'none';
        return (React.createElement(Panel, { className: "table-responsive", style: { display: display } },
            React.createElement(PalletBaseTable, { tariffRate: this.props.tariffRate, onChange: this.handlePricesDataChange() })));
    }
    renderWeightDistanceTable() {
        const display = this.props.tariffRate.type === 'weightDistance' ? 'block' : 'none';
        return (React.createElement(Panel, { className: "table-responsive", style: { display: display } },
            React.createElement(PalletBaseTable, { tariffRate: this.props.tariffRate, onChange: this.handlePricesDataChange() })));
    }
    renderOriginDestinationTable() {
        const display = this.props.tariffRate.type === 'originDestination' ? 'block' : 'none';
        return (React.createElement(Panel, { className: "table-responsive", style: { display: display } },
            React.createElement(OriginDestinationTable, { tariffRate: this.props.tariffRate, onChange: this.handleODPairsChange() })));
    }
    renderDay() {
        const tariffRate = this.props.tariffRate;
        const display = tariffRate.type === 'day' ? 'block' : 'none';
        return (React.createElement(Panel, { style: { display: display } },
            React.createElement(FormGroup, null,
                React.createElement(ControlLabel, null, "Rate per Day"),
                React.createElement(FormControl, { type: "number", defaultValue: tariffRate.rate_per_day, onChange: this.handleRatePerDayChange() }))));
    }
    render() {
        const disableDetail = !(this.props.tariffRate && this.props.tariffRate._id);
        return (React.createElement("div", null,
            React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: "1" },
                React.createElement(Row, { className: "clearfix" },
                    React.createElement(Col, { sm: 2 },
                        React.createElement(Nav, { bsStyle: "pills", stacked: true },
                            React.createElement(NavItem, { eventKey: "1" }, "Properties"),
                            React.createElement(NavItem, { eventKey: "2", disabled: disableDetail }, "Details"))),
                    React.createElement(Col, { sm: 10 },
                        React.createElement(Tab.Content, { animation: true },
                            React.createElement(Tab.Pane, { eventKey: "1" },
                                React.createElement(Panel, null,
                                    React.createElement(TariffRatesPropsEditor, { tariffRate: this.props.tariffRate, onChange: this.handlePropertiesChange() }))),
                            React.createElement(Tab.Pane, { eventKey: "2" },
                                this.renderWeightDistanceTable(),
                                this.renderOriginDestinationTable(),
                                this.renderDay(),
                                this.renderPalletBaseTable())))))));
    }
}
